import { Grid } from 'opensolar-ui'
import { useTranslate } from 'react-admin'
import type { OpenSolarThemeType } from 'Themes'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'
import useComponentSelectorColumnWidth from '../useComponentSelectorColumnWidth'

const useStyles = makeOpenSolarStyles((theme: OpenSolarThemeType) => ({
  header: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    // this padding is commented out since accordion functionality removed for phase 1
    // 60px for padding right accounts for placement of accordion dropdown
    // padding: '10px 60px 10px 10px',
    padding: '10px',
  },
  overflowItem: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  overflowItemCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export interface HeaderPropsType {
  hiddenColumnGroups?: Set<string>
}

const HardwareSelectorListHeader: React.FC<HeaderPropsType> = ({ hiddenColumnGroups }) => {
  const classes = useStyles()
  const translate = useTranslate()
  const hardwareSelectorColumnWidth = useComponentSelectorColumnWidth('hardware')

  return (
    <Grid container alignItems="center" xs={12} className={classes.header}>
      <Grid item xs={hardwareSelectorColumnWidth.item} style={{ paddingLeft: 20 }}>
        {translate('Item')}
      </Grid>
      <Grid
        item
        xs={hardwareSelectorColumnWidth.brand}
        className={`${classes.overflowItem} ${classes.overflowItemCenter}`}
      >
        {translate('Brand')}
      </Grid>
      <Grid item xs={hardwareSelectorColumnWidth.name} className={classes.overflowItem}>
        {translate('Name')}
      </Grid>
      {!hiddenColumnGroups?.has('rating') && (
        <Grid item xs={hardwareSelectorColumnWidth.rating}>
          {translate('Rating')}
        </Grid>
      )}
      {Number(hardwareSelectorColumnWidth.stock) > 0 && (
        <Grid item xs={hardwareSelectorColumnWidth.stock}>
          {translate('Stock')}
        </Grid>
      )}
      {Number(hardwareSelectorColumnWidth.source) > 0 && (
        <Grid item xs={hardwareSelectorColumnWidth.source} className={classes.overflowItem}>
          {translate('Select Source')}
        </Grid>
      )}
      {Number(hardwareSelectorColumnWidth.price) > 0 && (
        <Grid item xs={hardwareSelectorColumnWidth.price} className={classes.overflowItem}>
          {translate('Price')}
        </Grid>
      )}
      <Grid item xs={hardwareSelectorColumnWidth.action}></Grid>
    </Grid>
  )
}

export default HardwareSelectorListHeader
